<template>
    <section class="content-section container px-3">
        <h2 class="content-section-title mb-4">{{title.toUpperCase()}}</h2>
        <p class="text-main-aux">{{subDese}}</p>
        <b-row class="justify-content-start">
            <div v-for="(info, index) in infos" :key="index" class="an-wrap">
                <An :info="info" />    
            </div>
        </b-row>
    </section>
</template>

<script>
import An from '@/components/AnimateSmallBanner'

export default {
    components: { An },
    data() {
        return {
            title: "one-stop manufacturing process",
            subDese: "With systematic and strict quality control, we always deliver confident and good products. Processing every production step strictly is the top priority we do.",
            infos: [
                {"title":"Incoming","desc":"Scale: 3,000 pallet storage shelves<br>Raw Materials: Rubber, plastic, steel, and packaging...etc.", "img": require('@/assets/images/production/step-1.jpg')},
                {"title":"Rubber Dept.","desc":"Scale: 30 rubber molding machines<br>Capacity: 200,000 pieces/Day", "img": require('@/assets/images/production/step-2.jpg')},
                {"title":"Injection Dept.","desc":"Scale: 25 injection molding machines<br>Capacity: 40,000 pieces/Day", "img": require('@/assets/images/production/step-3.jpg')},
                {"title":"Stamping Dept.","desc":"Scale: 20 punching machines 25T~160T<br>Capacity: 700,000 pieces/Day", "img": require('@/assets/images/production/step-4.jpg')},
                {"title":"Painting Dept.","desc":"Scale: 450m automatic paint line<br>Capacity: 1.1 million pieces/Day", "img": require('@/assets/images/production/step-5.jpg')},
                {"title":"Assembly Dept.","desc":"Scale: 20 assembly lines<br>Capacity: 400,000 pieces/Day", "img": require('@/assets/images/production/step-6.jpg')},
                {"title":"Packaging Dept.","desc":"Scale: 12 packaging production lines<br>Capacity: 300,000 pieces/Day", "img": require('@/assets/images/production/step-7.jpg')},
                {"title":"Warehouse","desc":"Scale: 1,800 pallet storage shelves<br>Capacity: 200 containers shipped /Month", "img": require('@/assets/images/production/step-8.jpg')},
            ]
        }
    },
}
</script>

<style lang="scss">
    .an-wrap {
        flex:0 0 48%;
        margin-left: 1%;
        margin-right: 1%;
        margin-bottom: 15px;
    }
    @media (min-width: 992px) {
        .an-wrap{
            flex: 0 0 23%;
            margin-left: 1%;
            margin-right: 1%;
        }
    }
</style>